<template>
<div class="mypage">
  <div class="btn-area">
    <q-btn
      icon="far fa-trash-alt"
      rounded flat
      @click="deleteScore"
      color="red"
      size="25px"
      align="center"
      v-if="checks.length !== 0"
    />
    <q-btn
      icon="fas fa-sign-out-alt"
      rounded flat
      @click="signOut"
      size="25px"
    />
  </div>

  <q-list highlight link separator style="padding-bottom: 100px">
  <q-progress indeterminate stripe animate color="teal-2" v-if="isProgress" />
    <q-list-header>History</q-list-header>
    <q-item v-for="(score, index) in myScores" :key="score.ID" :to="{ name: 'Score', params:{ id: score.ID }}" style="padding-left: 10px">
      <q-checkbox v-model="checks" :val="score.ID" color="red"
       checked-icon="far fa-check-circle"
       unchecked-icon="far fa-circle"
       indeterminate-icon="far fa-circle"
       :key="score.ID"
      />
      <!-- v-model=""-->
      <q-item-main :label="combineMemberName(score.member)" style="margin-left:10px;" />
      <q-item-side right :stamp="score.targetDate" />

    </q-item>
  </q-list>
</div>
</template>

<style  lang="scss" scoped>
  .btn-area {
    text-align: right;
  }
  .q-fab .q-btn {
    height: 30px;
    width: 30px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
</style>

<script>
import firebase from 'firebase'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'MyPage',
  mounted () {
    this.isProgress = true
    this.checkLogin()
  },
  data () {
    return {
      myScores: [],
      isProgress: true,
      checks: []
    }
  },
  computed: {
    ...mapGetters('UserInfo', {
      myUID: 'getMyUID'
    })
  },
  methods: {
    ...mapMutations('UserInfo', {
      setMyUID: 'setMyUID'
    }),
    checkLogin () {
      let db = firebase.firestore()
      let settings = {timestampsInSnapshots: true}
      db.settings(settings)
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          // User is signed in.
          this.getScoreIDFromScoreHistory(user.uid)
          this.setMyUID(user.uid)
        } else {
          // No user is signed in.
          this.goLoginPage()
        }
      })
    },
    goLoginPage () {
      this.$router.push({ name: 'Login' })
    },
    getScoreIDFromScoreHistory (uid) {
      const db = firebase.firestore()
      db.collection('Users').doc(uid).collection('ScoreHistory').orderBy('timestamp', 'desc').get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
        // doc.data() is never undefined for query doc snapshots
          if (doc.exists) {
            const targetDate = this.changeToDateFromTimeStamp(doc.data().timestamp.seconds)
            let targetData = doc.data()
            targetData.targetDate = targetDate
            targetData.ID = doc.data().scoreID
            this.myScores.push(targetData)
          }
          this.isProgress = false
        })
      })
    },
    changeToDateFromTimeStamp (intTime) {
      const d = new Date(intTime * 1000)
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hour = ('0' + d.getHours()).slice(-2)
      const min = ('0' + d.getMinutes()).slice(-2)
      const sec = ('0' + d.getSeconds()).slice(-2)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec)
    },
    signOut () {
      firebase.auth().signOut()
        .then(_ => {
          this.goLoginPage()
        })
    },
    combineMemberName (member) {
      let res = ''
      for (let key in member) {
        res += ' ' + member[key].name
      }
      return res
    },
    deleteScore () {
      for (let key in this.checks) {
        this.myScores.some((v, i) => {
          if (v.ID === this.checks[key]) this.myScores.splice(i, 1)
        })
        const db = firebase.firestore()
        db.collection('Users').doc(this.myUID).collection('ScoreHistory').doc(this.checks[key]).delete()
      }
      this.checks = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MyPage.vue